import React from 'react'

const Icon = (props) => (
  <svg
    className={props.name ? `icon icon-${props.name}` : ''}
    width={props.width}
    height={props.height}
    margin-right={props.marginRight}
    aria-label={props.ariaLabel}
  >
    <use xlinkHref={`#${props.name}`} />
    {props.children}
  </svg>
)

export default Icon
